var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRupeeGreenFilled = function SvgRupeeGreenFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.5,
    fill: "url(#rupeeGreenFilled_svg__a)",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.13 13.77h-3.82c.84.63 1.38 1.52 1.57 2.53h2.25v1.57H23.9c-.28 2.27-1.95 3.54-3.66 3.82l3.82 6.14h-3.17l-3.47-5.84h-2.56v-2.42h3.59c1.24 0 2.2-.66 2.56-1.71h-6.14v-1.57h6.17c-.3-1.08-1.29-1.69-2.58-1.69h-3.59v-2.42h11.25v1.57z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rupeeGreenFilled_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(101.271 2.046 18.409)scale(23.0524)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B873A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#156B2E"
  })))));
};
export default SvgRupeeGreenFilled;